export const DEVENV_DOMAIN_SUFFIX = 'devenv.norm.ai';

export function isDevenvEnvironment(): boolean {
  const rootDomain =
    process.env.NEXT_PUBLIC_ALLOWED_ROOT_DOMAIN ||
    process.env.ALLOWED_ROOT_DOMAIN ||
    '';

  return rootDomain.endsWith(`.${DEVENV_DOMAIN_SUFFIX}`);
}
